module.exports = __webpack_public_path__ + "static/media/cdsf.ac4b96fc.jpg";